<template>
  <div>
    <div v-if="focus" @click="focus=false" class="overlay"></div>
    <section
      class="global-search"
      v-bind:class="[backgroundColorGray ? 'section-gray' : '', focus ? 'focus' : '', showVideo ? 'home-search' : '']"
    >
      <div class="bg-video" v-if="showVideo">
        <video class="bg-video__content" autoplay muted id="video" :key="url">
          <source :src="url" type="video/mp4">Your browser is not supported!
        </video>
      </div>

      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <h1
              v-if="hasTitle"
              class="text-center search-section brand-primary text-lg-left"
            >Encontre seu produto</h1>
            <div class="clearfix search-bar">
              <input
                type="text"
                class="form-control"
                placeholder="Busque pelo produto, filtro ou equivalência"
                v-model="searchData"
                @keyup.enter="search"
                @click="focus = true"
              >
              <button type="button" class="btn btn-primary btn-search" @click.prevent="search">
                <i class="icon-search"></i>
              </button>
            </div>
          </div>
        </div>

        <div v-if="$route.name === 'Home'" class="mt-5 d-flex justify-content-center align-items-center">
          <button class="btn btn-primary" @click="showAdvancedFilters = !showAdvancedFilters">Busca Avançada</button>
        </div>

        <div v-if="showAdvancedFilters" class="filters clearfix d-md-flex align-items-end">
          <div class="form-group">
            <label for="product">Tipo do Produto</label>
            <div>
              <select class="form-control" id="product" name="product" @change="getProductFilters($event.target.value)" v-model="selectedProduct">
                <option disabled>Selecione</option>
                <option>Veículos</option>
                <option>Peças</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label for="category">Categoria</label>
            <div>
              <select class="form-control" id="category" name="category" @change="getManufacturers($event.target.value)" v-model="selectedCategory">
                <option disabled>Selecione</option>
                <option v-for="item in categories" v-bind:value="item">{{item}}</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label for="brand">Montadora</label>
            <div>
              <select class="form-control" id="brand" name="brand" @change="getModels($event.target.value)" v-model="selectedManufacturers">
                <option disabled>Selecione</option>
                <option v-for="item in manufacturers" v-bind:value="item">{{item}}</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label for="model">Modelo</label>
            <div>
              <select class="form-control" id="model" name="model" @change="getVersions($event.target.value)" v-model="selectedModel">
                <option disabled>Selecione</option>
                <option v-for="item in models" v-bind:value="item">{{item}}</option>
              </select>
            </div>
          </div>
          <div class="form-group" v-if="currentProduct === 'Veículos'">
            <label for="motor">Versão</label>
            <div>
              <select class="form-control" id="version" name="version" @change="getEngines($event.target.value)" v-model="selectedVersion">
                <option disabled>Selecione</option>
                <option v-for="item in versions" v-bind:value="item">{{item}}</option>
              </select>
            </div>
          </div>
          <div class="form-group" v-if="currentProduct === 'Veículos'">
            <label for="motor">Motor</label>
            <div>
              <select class="form-control" id="motor" name="motor" @change="getYear($event.target.value)" v-model="selectedEngine">
                <option disabled>Selecione</option>
                <option v-for="item in engines" v-bind:value="item">{{item}}</option>
              </select>
            </div>
          </div>
          <div class="form-group" v-if="currentProduct === 'Veículos'">
            <label for="year">Ano</label>
            <div>
              <select class="form-control" id="year" name="year" v-model="selectedYear">
                <option disabled>Selecione</option>
                <option v-for="item in year">{{item}}</option>
              </select>
            </div>
          </div>
          <div class="col-auto px-0">
            <button
              class="col btn btn-primary btn-search"
              :class="[currentProduct === 'Selecione' ? 'btn disabled' : '']"
              @click="getProduct"
              :disabled="currentProduct === 'Selecione'"
            >Buscar</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import PartAPI from "@/api/part";
import VehicleAPI from "@/api/vehicle.vue";
import { escapeReservedUrlCharacters, removeSpecialCharacters } from "@/utils/escape.js";
import { sortArrayOfStringAlphabetically } from "@/utils/array.js";

export default {
  props: {
    align: String,
    backgroundColorGray: {
      type: Boolean,
      default: false
    },
    hasTitle: {
      type: Boolean,
      default: false
    },
    showVideo: {
      type: Boolean,
      default: false
    },
    searchData: String
  },
  data() {
    return {
      url: "https://static.japanparts.com.br/reverse.mp4",
      reverse: true,
      focus: false,

      filters: "",
      showAdvancedFilters: false,

      currentProduct: "Selecione",
      selectedProduct: "Selecione",
      selectedCategory: "Selecione",
      selectedManufacturers: "Selecione",
      selectedModel: "Selecione",
      selectedVersion: "Selecione",
      selectedEngine: "Selecione",
      selectedYear: "Selecione",

      vehicles: [],
      parts: [],

      categories: [],
      manufacturers: [],
      models: [],
      versions: [],
      engines: [],
      year: [],

      branchedFilters: {}
    };
  },
  mounted() {
    if (this.showVideo) {
      this.changeVideo();
    }
  },
  methods: {
    changeVideo() {
      let video = document.getElementById("video");
      let intervalRewind;
      setInterval(() => {
        intervalRewind = setInterval(function() {
          video.playbackRate = 1.0;
          if (video.currentTime == 0) {
            clearInterval(intervalRewind);
            video.play();
          } else {
            video.currentTime += -0.1;
          }
        }, 30);
      }, 8000);
    },
    async search() {
      if (this.searchData && this.searchData.length >= 0) {

        const formattedSearchData = removeSpecialCharacters({
          string: this.searchData,
          replace: "",
          except: ["."]
        });

        if (formattedSearchData) {
          try {
            const cars = await VehicleAPI.search(
              formattedSearchData,
              "",
              "",
              1,
              this.$root.$data.itemsPerPage
            );

            const parts = await PartAPI.search(formattedSearchData);
            this.$root.$data.searchData = formattedSearchData;
            this.$root.$data.cars = cars.data;
            this.$root.$data.parts = parts.data;

            let find = parts.data.hits.find(
              item =>
                item.code_formatted.toUpperCase() === formattedSearchData.toUpperCase() ||
                (item.original? item.original.equivalence_code_formatted.toUpperCase() : " ") ==
                  formattedSearchData.toUpperCase() ||
                item.equivalencies.find(
                  equiv =>
                    equiv.equivalence_code_formatted.toUpperCase() ==
                    formattedSearchData.toUpperCase()
                )
            );


            if (find) {
              this.$router.push(`/produto/${find.code}`);
            } else {
              this.$router.push("/produtos");
            }
            this.focus = false;
          } catch (err) {
            console.log(err);
          }
        }
      }
    },

    async getProductFilters(product) {
      try {
        if (this.currentProduct !== product) {
          this.vehicles = [];
          this.parts = [];

          if (this.selectedProduct === "Veículos") {
            const {
              data: { children }
            } = await VehicleAPI.getAllFilters();
            this.branchedFilters = children;
          } else {
            const {
              data: { children }
            } = await PartAPI.getAllFilters();
            this.branchedFilters = children;
          }

          this.currentProduct = product;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.categories = this.filterInvalidValues(this.branchedFilters);

        this.clearFields(
          [
            "selectedCategory",
            "selectedManufacturers",
            "selectedModel",
            "selectedVersion",
            "selectedEngine",
            "selectedYear"
          ],
          ["manufacturers", "models", "version", "engines", "year"]
        );
      }
    },

    filterInvalidValues(filters) {
      const filteredFilters = Object.keys(filters).filter(filter => !!filter && filter !== 'null')
      return sortArrayOfStringAlphabetically(filteredFilters);
    },

    formatFilters() {
      let filters = [];

      if (this.currentProduct === "Veículos") {
        filters = [
          { name: "line", value: this.selectedCategory },
          { name: "manufacturer", value: this.selectedManufacturers },
          { name: "model", value: this.selectedModel },
          { name: "version", value: this.selectedVersion },
          { name: "engine", value: this.selectedEngine },
          { name: "year", value: this.selectedYear }
        ];
      } else {
        filters = [
          { name: 'category', value: this.selectedCategory },
          { name: 'model', value: this.selectedModel },
          { name: 'manufacturer', value: this.selectedManufacturers }
        ]
      }

      const formattedFilters = [];

      filters.map(filter => {
        if (filter.value && filter.value !== 'Selecione') {
          formattedFilters.push(`${filter.name}=${escapeReservedUrlCharacters(filter.value)}`);
        }
      });

      this.filters = formattedFilters.join("&");
    },

    formatYear(index) {
      let formattedDate;

      if (this.selectedYear && this.selectedYear !== "Selecione") {
        const year = this.selectedYear.split("|")[index].trim();

        if (!["<--", "-->"].includes(year)) {
          formattedDate = new Date(year, 0).toISOString().split("T")[0];
        } else {
          formattedDate = null;
        }
      }
      return sortArrayOfStringAlphabetically(formattedDate);
    },

    async getProduct() {
      if (this.searchData) {
        const cars = await VehicleAPI.search(this.searchData);
        const parts = await PartAPI.search(this.searchData);
        this.$root.$data.searchData = this.searchData;
        this.$root.$data.cars = cars.data;
        this.$root.$data.parts = parts.data;
      }
      this.formatFilters();
      this.$router.push(
        `/produtos?product=${this.selectedProduct}&${this.filters}`
      );
    },

    getManufacturers(filter) {
      this.manufacturers = this.filterInvalidValues(
        this.branchedFilters[this.selectedCategory]
      );
      this.clearFields(
        [
          "selectedManufacturers",
          "selectedModel",
          "selectedVersion",
          "selectedEngine",
          "selectedYear"
        ],
        ["models", "version", "engines", "year"]
      );
    },

    getModels(filter) {
      this.models = this.filterInvalidValues(
        this.branchedFilters[this.selectedCategory][filter]
      );
      this.clearFields(
        ["selectedModel", "selectedVersion", "selectedEngine", "selectedYear"],
        ["version", "engines", "year"]
      );
    },

    getVersions(filter) {
      this.versions = this.filterInvalidValues(
        this.branchedFilters[this.selectedCategory][this.selectedManufacturers][
          filter
        ]
      );
      this.clearFields(
        ["selectedVersion", "selectedEngine", "selectedYear"],
        ["engines", "year"]
      );
    },

    getEngines(filter) {
      this.engines = this.filterInvalidValues(
        this.branchedFilters[this.selectedCategory][this.selectedManufacturers][
          this.selectedModel
        ][filter]
      );
      this.clearFields(["selectedEngine", "selectedYear"], ["year"]);
    },

    getYear(filter) {
      const vehicles = this.branchedFilters[this.selectedCategory][
        this.selectedManufacturers
      ][this.selectedModel][this.selectedVersion][filter];
      const formattedYear = [];

      const formatter = (date, nullReplacer) => {
        if (date) {
          const formattedDate = new Date(date);
          return `${String(formattedDate.getUTCMonth() + 1).padStart(
            2,
            0
          )}/${String(formattedDate.getUTCFullYear())}`;
        }

        return nullReplacer;
      };

      vehicles.map(vehicle => {
        if (vehicle.yearFrom || vehicle.yearTo) {
          formattedYear.push(
            `${formatter(vehicle.yearFrom, "<--")} | ${formatter(
              vehicle.yearTo,
              "-->"
            )}`
          );
        }
      });

      this.year = formattedYear;

      this.clearFields(["selectedYear"], []);
    },

    clearFields(selected, filters) {
      selected.forEach(item => {
        this[item] = "Selecione";
      });
      filters.forEach(filter => {
        this[filter] = [];
      });
    }
  }
};
</script>

<style>
.bg-video {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  opacity: 0.4;
  overflow: hidden;
}

.bg-video__content {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.global-search {
  background-color: white;
}

.home-search {
  min-height: 300px;
}

.overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}

.focus {
  z-index: 9999;
  box-shadow: 0 8px 20px 0 rgba(158, 184, 209, 0.43);
}

.custom-select-box {
  pointer-events: auto !important;
}

.table-wrapper {
  max-height: 300px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchBar.vue